module.exports = __webpack_public_path__ + "img/mt-s.54ace881.png";